/**
 * Initials + a deterministic colour for placeholder avatars (when a user has
 * no photo). The colour is derived from a stable seed (user id / name) so the
 * same person always gets the same colour — it must NOT be random per render,
 * or it would flicker on every re-render.
 */

export function getInitials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Saturated-but-calm hues that read well with white initials on a dark UI.
const AVATAR_COLORS = [
  '#E8743B', '#19A979', '#945ECF', '#13A4B4', '#525DF4',
  '#BF399E', '#5C8A3A', '#EE6868', '#2F6497', '#C7902A',
];

/** Stable colour for a seed string (user id preferred, else name). */
export function avatarColor(seed: string | null | undefined): string {
  const s = seed ?? '';
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash << 5) - hash + s.charCodeAt(i);
    hash |= 0; // keep 32-bit
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
